import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=53057eb4"
import script from "./MainLoading.vue?vue&type=script&lang=js"
export * from "./MainLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports